// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"482":"charts","824":"portfolio"}[chunkId] || chunkId) + "." + {"74":"2603eb9a","134":"68f92968","180":"e4da614e","329":"f6c2ef21","447":"4822fa93","448":"4e1bc40d","482":"0262a783","761":"2e592e0f","819":"ae706161","824":"94fa6bbd","927":"8b17cc39","951":"70a52edd","974":"b5c25dd1"}[chunkId] + ".js";
};